import { of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { get } from 'lodash';
import getClientInstance from '../../config/apollo-client';
import safeJsonParse from '../utils/safeJsonParse';

import {
  FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_START,
  GRANT_EMR_MANAGER_ROLE_TO_ADMIN_START,
  REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_START
} from './action-types';

import {
  fetchGrantRevokeEmrManagerRoleButtonsComplete,
  fetchGrantRevokeEmrManagerRoleButtonsError,
  grantEmrManagerRoleToAdminSuccess,
  grantEmrManagerRoleToAdminError,
  revokeEmrManagerRoleFromAdminSuccess,
  revokeEmrManagerRoleFromAdminError
} from './actions';

import fetchGrantRevokeEmrManagerRoleButtons from '../graphql/queries/fetch_grant_revoke_emr_manager_role_buttons.graphql';
import grantEmrManagerRoleToAdmin from '../graphql/mutations/grant_emr_manager_role_to_admin.graphql';
import revokeEmrManagerRoleFromAdmin from '../graphql/mutations/revoke_emr_manager_role_from_admin.graphql';

export const fetchGrantRevokeEmrManagerRoleButtonsStart = (action$, state$) =>
  action$.pipe(
    ofType(FETCH_GRANT_REVOKE_EMR_MANAGER_ROLE_BUTTONS_START),
    switchMap((action) => {
      const apolloClient = getClientInstance();
      const currentAdminId = action.payload.currentAdminId;
      const adminIds = action.payload.adminIds;

      const apolloResult = apolloClient
        .query({
          query: fetchGrantRevokeEmrManagerRoleButtons,
          variables: { adminId: currentAdminId, adminIds }
        })
        .then((result) => {
          const shouldDisplay =
            safeJsonParse(get(result, 'data.admin.shouldDisplayGrantRevokeButtons'));
          const admins =
            safeJsonParse(get(result, 'data.admin.fetchAdminsWithAndWithoutEmrManagerRole'));

          return fetchGrantRevokeEmrManagerRoleButtonsComplete({ shouldDisplay, admins });
        })
        .catch((error) => {
          return fetchGrantRevokeEmrManagerRoleButtonsError(error);
        });

      return of(apolloResult);
    }));

export const grantEmrManagerRoleToAdminStart = (action$, state$) =>
  action$.pipe(
    ofType(GRANT_EMR_MANAGER_ROLE_TO_ADMIN_START),
    switchMap((action) => {
      const apolloClient = getClientInstance();
      const adminId = parseInt(action.payload.adminId);

      const apolloResult = apolloClient
        .mutate({
          mutation: grantEmrManagerRoleToAdmin,
          variables: { adminId }
        })
        .then((result) => {
          const status = get(result, 'data.grantEmrManagerRole.status');

          if (status == 'success') {
            return grantEmrManagerRoleToAdminSuccess({ adminId });
          } else {
            return grantEmrManagerRoleToAdminError({ error: status, adminId });
          }
        })
        .catch((error) => {
          return grantEmrManagerRoleToAdminError({ error, adminId });
        });

      return of(apolloResult);
    }));

export const revokeEmrManagerRoleFromAdminStart = (action$, state$) =>
  action$.pipe(
    ofType(REVOKE_EMR_MANAGER_ROLE_FROM_ADMIN_START),
    switchMap((action) => {
      const apolloClient = getClientInstance();
      const adminId = parseInt(action.payload.adminId);

      const apolloResult = apolloClient
        .mutate({
          mutation: revokeEmrManagerRoleFromAdmin,
          variables: { adminId }
        })
        .then((result) => {
          const status = get(result, 'data.revokeEmrManagerRole.status');

          if (status == 'success') {
            return revokeEmrManagerRoleFromAdminSuccess({ adminId });
          } else {
            return revokeEmrManagerRoleFromAdminError({ error: status, adminId });
          }
        })
        .catch((error) => {
          return revokeEmrManagerRoleFromAdminError({ error, adminId });
        });

      return of(apolloResult);
    }));

export default combineEpics(
  fetchGrantRevokeEmrManagerRoleButtonsStart,
  grantEmrManagerRoleToAdminStart,
  revokeEmrManagerRoleFromAdminStart
);
